(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dimvra-classic-video"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dimvra-video-player')){
customElements.define('dimvra-video-player',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;
const video=this.querySelector('video'),button=this.querySelector('.dvv-center-play');
if(!video||!button)return;
this.initialized=true;
video.playbackRate=Number(this.dataset.speed)||1;
const update=()=>{button.hidden=!video.paused&&!video.ended};
update();
video.addEventListener('play',update);video.addEventListener('pause',update);video.addEventListener('ended',update);
button.addEventListener('click',()=>{video.play().catch(()=>{button.hidden=false})});
video.addEventListener('click',event=>{
const bounds=video.getBoundingClientRect();
if(event.clientY>bounds.bottom-48)return;
event.preventDefault();
if(video.paused||video.ended){video.play().catch(()=>{button.hidden=false})}else{video.pause()}
});
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dimvra-image-compare"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dimvra-image-compare')){
customElements.define('dimvra-image-compare',class extends HTMLElement{
connectedCallback(){
if(this.cleanup)return;
const input=this.querySelector('.dvc-range'),media=this.querySelector('.dvc-media');if(!input||!media)return;
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
let active=false,manual=false,hover=false,scrolling=false,frame=0,timer=0,base=Number(input.value),phase=0,last=0;
const set=value=>{const next=Math.min(100,Math.max(0,value));this.style.setProperty('--dvc-position',next+'%');input.value=next;};
const allowed=()=>active&&!manual&&!reduced.matches&&!document.hidden&&this.dataset.motion==='true'&&(hover||!scrolling);
const tick=time=>{frame=0;if(!allowed()){last=0;return}if(last)phase+=Math.min(time-last,50)/1000;last=time;const cycle=phase%9;set(cycle<4?base+Math.sin(cycle*Math.PI/2)*Number(this.dataset.amplitude??2):base);frame=requestAnimationFrame(tick);};
const request=()=>{if(allowed()&&!frame)frame=requestAnimationFrame(tick);else if(!allowed()){cancelAnimationFrame(frame);frame=0;last=0;}};
const scroll=()=>{scrolling=true;clearTimeout(timer);request();timer=setTimeout(()=>{scrolling=false;request()},260)};
const stop=()=>{manual=true;request()};
const onInput=()=>{manual=true;base=Number(input.value);phase=0;set(base);request()};
const enter=()=>{hover=true;request()},leave=()=>{hover=false;request()};
input.addEventListener('input',onInput);input.addEventListener('pointerdown',stop);input.addEventListener('keydown',stop);
media.addEventListener('pointerenter',enter);media.addEventListener('pointerleave',leave);
const observer=new IntersectionObserver(entries=>{active=entries[0].isIntersecting;if(!active){manual=false;base=Number(input.value);phase=0;}request()});
observer.observe(media);window.addEventListener('scroll',scroll,{passive:true,capture:true});document.addEventListener('visibilitychange',request);reduced.addEventListener('change',request);
set(base);
this.cleanup=()=>{observer.disconnect();cancelAnimationFrame(frame);clearTimeout(timer);window.removeEventListener('scroll',scroll,true);document.removeEventListener('visibilitychange',request);reduced.removeEventListener('change',request);input.removeEventListener('input',onInput);input.removeEventListener('pointerdown',stop);input.removeEventListener('keydown',stop);media.removeEventListener('pointerenter',enter);media.removeEventListener('pointerleave',leave);this.cleanup=null};
}
disconnectedCallback(){this.cleanup?.()}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dimvra-new-products"] && !Shopify.designMode) return;
  try {
    
  function initNewProducts(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const viewport = root.querySelector('[data-new-products-viewport]');
    const prev = root.querySelector('[data-new-products-prev]');
    const next = root.querySelector('[data-new-products-next]');
    if (!viewport) return;
    const move = (direction) => {
      const card = viewport.querySelector('.dnp-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(viewport.querySelector('.dnp__track')).columnGap) || 0;
      viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };
    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));

    root.addEventListener('submit', async (event) => {
      const form = event.target.closest('.dnp-card__form');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('.dnp-card__button');
      if (!button || button.disabled) return;
      const originalText = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const addUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        const addedItem = await response.json();
        if (!response.ok) throw new Error(addedItem.description || 'Unable to add item');

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' }
        });
        const cart = await cartResponse.json();

        document.querySelectorAll('[data-cart-count], .cart-bubble__text-count, [data-testid="cart-bubble"], .cart-count-bubble span[aria-hidden="true"]').forEach((count) => {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        });

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { cart, resource: cart, item: addedItem, sourceId: 'dimvra-new-products' }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart, resource: cart, item: addedItem, sourceId: 'dimvra-new-products' }
        }));

        button.textContent = '✓';
        button.classList.add('dnp-card__button--success');
        window.setTimeout(() => {
          button.textContent = originalText;
          button.classList.remove('dnp-card__button--success');
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }, 1100);
      } catch (error) {
        button.textContent = originalText;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        window.alert(error.message);
      }
    });
  }

  document.querySelectorAll('[data-new-products]').forEach(initNewProducts);
  document.addEventListener('shopify:section:load', (event) => initNewProducts(event.target.querySelector('[data-new-products]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
if(!window.dimvraProductTabsBound){
document.addEventListener('click',event=>{
const button=event.target.closest('.dv-tabs-toggle');if(!button)return;
const content=document.getElementById(button.getAttribute('aria-controls'));if(!content)return;
content.hidden=!content.hidden;button.setAttribute('aria-expanded',String(!content.hidden));button.setAttribute('aria-label',content.hidden?'Expand product information':'Collapse product information');
});
window.dimvraProductTabsBound=true;
const activate=(tab,focus=false)=>{
const root=tab.closest('.dv-product-tabs');
root.querySelector('.dv-tabs-content').hidden=false;const toggle=root.querySelector('.dv-tabs-toggle');toggle.setAttribute('aria-expanded','true');toggle.setAttribute('aria-label','Collapse product information');
root.querySelectorAll('[role="tab"]').forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;const panel=document.getElementById(item.getAttribute('aria-controls'));if(panel)panel.hidden=!selected});
if(focus)tab.focus();
};
document.addEventListener('click',event=>{
const tab=event.target.closest('.dv-product-tabs [role="tab"]');if(!tab)return;
const root=tab.closest('.dv-product-tabs'),content=root.querySelector('.dv-tabs-content'),toggle=root.querySelector('.dv-tabs-toggle');
if(tab.getAttribute('aria-selected')==='true'&&content&&!content.hidden){
content.hidden=true;toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-label','Expand product information');
}else{activate(tab)}
});
document.addEventListener('keydown',event=>{
const tab=event.target.closest('.dv-product-tabs [role="tab"]');if(!tab)return;
const tabs=Array.from(tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));let index=tabs.indexOf(tab);
if(event.key==='ArrowRight')index=(index+1)%tabs.length;else if(event.key==='ArrowLeft')index=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')index=0;else if(event.key==='End')index=tabs.length-1;else return;
event.preventDefault();activate(tabs[index],true);
});
}

  } catch(e) { console.error(e); }
})();
})();
